module.exports = __webpack_public_path__ + "img/yff-banner.998efaf5.jpg";